import { FilterField, FilterFieldConfig, FilterFieldType } from '../filter';

export interface Tab {
  name: string;
  id: string;
}

export class TabbedFilterField extends FilterField<Tab> {
  readonly type: FilterFieldType = 'tabbed';
  options: Tab[];

  constructor(config: FilterFieldConfig) {
    super(config);
    this.value = config.value || config.options![0];
  }

  appliedFieldText(): string {
    return this.value!.name;
  }

  serializeValue(): string {
    return this.value!.id;
  }

  deserializeValue(urlParam: string): Tab | null {
    return this.options.find((tab) => tab.id === urlParam) || null;
  }
}
